export default class VideoBlock {
	constructor() {
		document.addEventListener( 'DOMContentLoaded', this.ready() );
	}

	ready() {
		const videos = document.getElementsByClassName('video__wrapper');

		[...videos].forEach((vid) => {

			const cover = vid.querySelector('.video__cover');
			const iframe = vid.querySelector('iframe');
			const video = vid.querySelector('video');
			const player = iframe ?? video;

			vid.addEventListener('click', () => this.onPlayClick( cover, player ));
		});

	}

	onPlayClick(cover, player) {

		cover.classList = cover.classList ?? '';
		cover.classList.add('hidden');

		const contentWindow = player?.contentWindow;

		if (contentWindow) {
			const url = new URL(player.src);
			url.searchParams.append('enablejsapi', '1');
			url.searchParams.append('autoplay', '1');

			player.src = url.href;


			player.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')


		} else {
			console.log(player);
			player.play();
		}
	}
}


